// ExternalLinkModal Component
// Displays a confirmation dialog when user clicks on external links
// Asks user if they want to open the link in a new tab

import React, { useState, useEffect } from 'react';
import { RevoltModal, RevoltButton } from './';
import './ExternalLinkModal.css';

export function ExternalLinkModal() {
  const [isOpen, setIsOpen] = useState(false);
  const [linkUrl, setLinkUrl] = useState(null);

  useEffect(() => {
    const handleExternalLink = (event) => {
      const { url } = event.detail;
      setLinkUrl(url);
      setIsOpen(true);
    };

    window.addEventListener('external-link:click', handleExternalLink);

    return () => {
      window.removeEventListener('external-link:click', handleExternalLink);
    };
  }, []);

  const handleConfirm = () => {
    if (linkUrl) {
      window.open(linkUrl, '_blank', 'noopener,noreferrer');
    }
    setIsOpen(false);
    setLinkUrl(null);
  };

  const handleCancel = () => {
    setIsOpen(false);
    setLinkUrl(null);
  };

  return (
    <RevoltModal
      isOpen={isOpen}
      onClose={handleCancel}
      title="Open External Link"
      containerClassName="external-link-modal"
      showCloseButton={false}
    >
      <div className="external-link-content">
        <div className="external-link-icon">
          <i className="fa-solid fa-external-link"></i>
        </div>
        <p className="external-link-message">
          You are about to open a link to an external website.
        </p>
        <div className="external-link-url">
          <span className="external-link-label">URL:</span>
          <span className="external-link-value">{linkUrl || ''}</span>
        </div>
        <p className="external-link-hint">
          This will open in a new tab. Do you want to continue?
        </p>
        <div className="external-link-actions">
          <RevoltButton variant="ghost" onClick={handleCancel}>
            Cancel
          </RevoltButton>
          <RevoltButton variant="accent" onClick={handleConfirm}>
            Yes, Open Link
          </RevoltButton>
        </div>
      </div>
    </RevoltModal>
  );
}

